import { render, staticRenderFns } from "./ParkingHistory.vue?vue&type=template&id=504903b8"
import script from "./ParkingHistory.vue?vue&type=script&lang=js"
export * from "./ParkingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports